<mat-card class="matCard">
    <mat-card-header class="matCardHeader">
        <mat-card-title> Add Item </mat-card-title>
    </mat-card-header>
    <mat-card-content class="matCardContainer">
        <div class="loadingShade"
            *ngIf="isLoading">
            <mat-spinner></mat-spinner>
        </div>
        <mat-stepper #stepper *ngIf="!isLoading" [linear]="true" class="formStepper" [orientation]="(stepperOrientation | async)!">
            <mat-step [stepControl]="generalInfoForm" label="General Information">
                <div class="stepContentWrapper">
                    <form [formGroup]="generalInfoForm" #generalInfoFGD="ngForm">
                        <section class="form-field-container">
                            <h3>Title</h3>
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="title" [errorStateMatcher]="errorMatcher" />
                                <mat-error *ngIf="title.invalid && title.touched">{{ getTitleErrorMessage() }} </mat-error>
                            </mat-form-field>
                        </section>

                        <section class="form-field-container about">
                            <h3>About</h3>
                            <h5>Provide details about the legislative item.</h5>
                            <mat-form-field appearance="outline">
                                <textarea
                                    matInput
                                    cdkTextareaAutosize
                                    formControlName="about"
                                    [errorStateMatcher]="errorMatcher"
                                ></textarea>
                                <mat-error *ngIf="about.invalid && about.touched && about.hasError('required')">
                                    Missing details for About section</mat-error
                                >
                            </mat-form-field>
                        </section>

                        <section class="form-field-container ourPosition">
                            <h3>Our Position</h3>
                            <h5>
                                Provide information about the School District's position on the legislative item and provide reasons
                                why that is the case.
                            </h5>
                            <mat-form-field appearance="outline">
                                <textarea
                                    matInput
                                    cdkTextareaAutosize
                                    formControlName="ourPosition"
                                    [errorStateMatcher]="errorMatcher"
                                ></textarea>
                                <mat-error *ngIf="ourPosition.invalid && ourPosition.touched && ourPosition.hasError('required')">
                                    Missing details for Our Position section</mat-error
                                >
                            </mat-form-field>
                        </section>
                        <div class="stepperButtons">
                            <button mat-stroked-button matStepperNext (click)="generalInfoForm.markAllAsTouched()">Next</button>
                        </div>
                    </form>
                </div>
            </mat-step>

            <mat-step [stepControl]="resourceLinksForm" label="Tracking/Resource Links">
                <div class="stepContentWrapper">
                    <form [formGroup]="resourceLinksForm" #resourceLinksFGD="ngForm">
                        <section class="tl-container">
                            <h3 clas="tl-header">Tracking Links</h3>
                            <div class="tl-button">
                                <button mat-flat-button color="primary" (click)="createTrackingLink()">Add</button>
                            </div>
                            <table
                                mat-table
                                #tlTable
                                class="tl-links"
                                [hidden]="trackingLinks.controls.length === 0"
                                [dataSource]="trackingLinks.controls"
                                formArrayName="trackingLinks"
                            >
                                <ng-container matColumnDef="sortOrder">
                                    <th mat-header-cell *matHeaderCellDef width="10"></th>
                                    <td mat-cell *matCellDef="let tracking; let i = index" [formGroupName]="i">{{ i + 1 }}</td>
                                </ng-container>

                                <ng-container matColumnDef="trackingLabel">
                                    <th mat-header-cell *matHeaderCellDef width="115">Label</th>
                                    <td mat-cell *matCellDef="let tracking; let i = index" [formGroupName]="i">
                                        <mat-form-field
                                            appearance="outline"
                                            style="width: 115px; padding-left: 5px; padding-right: 5px"
                                        >
                                            <input matInput formControlName="trackingLabel" [errorStateMatcher]="errorMatcher" />
                                            <mat-error *ngIf="tracking.invalid && tracking.get('trackingLabel').hasError('required')">
                                                Missing label</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="trackingLink">
                                    <th mat-header-cell *matHeaderCellDef>Tracking Link</th>
                                    <td mat-cell *matCellDef="let tracking; let i = index" [formGroupName]="i">
                                        <mat-form-field appearance="outline" style="width: 100%">
                                            <input matInput formControlName="trackingLink" [errorStateMatcher]="errorMatcher" />
                                            <mat-error *ngIf="tracking.invalid && tracking.get('trackingLink').hasError('required')">
                                                Missing link</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef width="20px"></th>
                                    <td mat-cell *matCellDef="let tracking; let i = index" class="deleteBtns" width="20px">
                                        <button mat-icon-button color="warn" (click)="deleteTrackingLink(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="trackingLinksColumns"></tr>
                                <tr mat-row *matRowDef="let row; let i = index; columns: trackingLinksColumns"></tr>
                            </table>
                        </section>

                        <section class="ar-container">
                            <h3 clas="ar-header">Additional Resource Links</h3>
                            <div class="ar-button">
                                <button mat-flat-button color="primary" (click)="createResource(); arTable.renderRows()">Add</button>
                            </div>

                            <table
                                mat-table
                                #arTable
                                class="ar-links"
                                [hidden]="resourceLinks.controls.length === 0"
                                [dataSource]="resourceLinks.controls"
                                formArrayName="resourceLinks"
                            >
                                <ng-container matColumnDef="sortOrder">
                                    <th mat-header-cell *matHeaderCellDef width="10"></th>
                                    <td mat-cell *matCellDef="let resource; let i = index" [formGroupName]="i">{{ i + 1 }}</td>
                                </ng-container>

                                <ng-container matColumnDef="resourceLabel">
                                    <th mat-header-cell *matHeaderCellDef width="115">Label</th>
                                    <td mat-cell *matCellDef="let resource; let i = index" [formGroupName]="i">
                                        <mat-form-field
                                            appearance="outline"
                                            style="width: 115px; padding-left: 5px; padding-right: 5px"
                                        >
                                            <input matInput formControlName="resourceLabel" [errorStateMatcher]="errorMatcher" />
                                            <mat-error *ngIf="resource.invalid && resource.get('resourceLabel').hasError('required')">
                                                Missing label</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="resourceLink">
                                    <th mat-header-cell *matHeaderCellDef>Resource Link</th>
                                    <td mat-cell *matCellDef="let resource; let i = index" [formGroupName]="i">
                                        <mat-form-field appearance="outline" style="width: 100%">
                                            <input matInput formControlName="resourceLink" [errorStateMatcher]="errorMatcher" />
                                            <mat-error *ngIf="resource.invalid && resource.get('resourceLink').hasError('required')">
                                                Missing link</mat-error
                                            >
                                        </mat-form-field>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef width="20px"></th>
                                    <td mat-cell *matCellDef="let resource; let i = index" class="deleteBtns" width="20px">
                                        <button mat-icon-button color="warn" (click)="deleteResource(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="additionalResourcesColumns"></tr>
                                <tr mat-row *matRowDef="let row; let i = index; columns: additionalResourcesColumns"></tr>
                            </table>
                        </section>
                        <div class="stepperButtons">
                            <button mat-stroked-button matStepperPrevious>Back</button>
                            <button mat-stroked-button matStepperNext (click)="resourceLinksForm.markAllAsTouched()">Next</button>
                        </div>
                    </form>
                </div>
            </mat-step>

            <mat-step [stepControl]="emailOptionsForm" label="Email Options">
                <div class="stepContentWrapper">
                    <form [formGroup]="emailOptionsForm" #emailOptionsFGD="ngForm">
                        <div class="fomrEmail">
                            <section class="form-field-container">
                                <h3>Email Subject</h3>
                                <h5>Add email subject to be prefilled into email template form.</h5>
                                <mat-radio-group
                                    class="radioGroup"
                                    aria-label="Select an option"
                                    formControlName="subjectOptions"
                                    (change)="onToggleSubject($event)"
                                >
                                    <mat-radio-button class="radioButton" value="1" (change)="revertEmailSubjectStatuses()"
                                        >Use Title as the subject for the template
                                    </mat-radio-button>
                                    <mat-radio-button class="radioButton" value="2"
                                        >Add a custom email subject
                                    </mat-radio-button>
                                </mat-radio-group>
                                <div [hidden]="subjectOptions.value === '1'">
                                    <mat-form-field style="width: 100%" appearance="outline">
                                        <input
                                            matInput
                                            type="text"
                                            [errorStateMatcher]="errorMatcher"
                                            formControlName="emailSubject"
                                        />
                                        <mat-error
                                            *ngIf="emailSubject.invalid && emailSubject.touched && emailSubject.hasError('required')"
                                        >
                                            Plese enter in a subject for the email template</mat-error
                                        >
                                    </mat-form-field>
                                </div>
                            </section>

                            <section class="form-field-container">
                                <h3>Email Recipients</h3>
                                <h5>Select from the list who will be receiving the email submission for this item.</h5>
                                <mat-tab-group dynamicHeight animationDuration="0ms">
                                    <mat-tab label="Group">
                                        <mat-selection-list
                                            #groupList
                                            [compareWith]="compareGroups"
                                            [formControl]="groupsListForm"
                                            (click)="$event.stopPropagation()"
                                        >
                                            <mat-list-option *ngFor="let group of recipientsByGroups" [value]="group" checkboxPosition="before">
                                                {{ group.groupName }}
                                            </mat-list-option>
                                        </mat-selection-list>
                                    </mat-tab>
                                    <mat-tab label="Individual"> 
                                        <mat-selection-list
                                            #peopleList
                                            [compareWith]="compareRecipients"
                                            [formControl]="recipient"
                                            (click)="$event.stopPropagation()"
                                        >
                                            <mat-list-option *ngFor="let recip of recipients" [value]="recip" checkboxPosition="before">
                                                {{ recip.name }}
                                            </mat-list-option>
                                        </mat-selection-list>
                                    </mat-tab>
                                </mat-tab-group>
                            </section>

                            <section class="tp-container">
                                <div class="tp-header">
                                    <h3>Message Talking Points</h3>
                                    <h5>Provide talking points to assist users in expressing their opinions on the subject.</h5>
                                </div>
                                <div class="tp-button">
                                    <button
                                        mat-flat-button
                                        color="primary"
                                        (click)="createTalkingPoint()"
                                        [class.matErrorButton]="
                                            talkingPoints.invalid && talkingPoints.touched && talkingPoints.hasError('required')
                                        "
                                    >
                                        Add
                                    </button>
                                </div>
                                <div class="form-field-container tp-links">
                                    <mat-error
                                        *ngIf="talkingPoints.invalid && talkingPoints.touched && talkingPoints.hasError('required')"
                                    >
                                        No talking points listed
                                    </mat-error>
                                    <ng-container
                                        formArrayName="talkingPoints"
                                        *ngFor="let tp of talkingPoints.controls; let i = index"
                                    >
                                        <mat-form-field [formGroupName]="i" appearance="outline">
                                            <textarea
                                                type="text"
                                                matInput
                                                cdkTextareaAutosize
                                                [errorStateMatcher]="errorMatcher"
                                                formControlName="talkingPoint"
                                            ></textarea>

                                            <button
                                                *ngIf="tp.value"
                                                color="warn"
                                                matSuffix
                                                mat-icon-button
                                                aria-label="Remove Talking Point"
                                                (click)="deleteTalkingPoint(i)"
                                            >
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                            <mat-error *ngIf="tp.invalid && tp.get('talkingPoint').hasError('required')">
                                                Missing details of talking point</mat-error
                                            >
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                            </section>
                        </div>
                        <div class="stepperButtons">
                            <button mat-stroked-button matStepperPrevious>Back</button>
                            <button mat-stroked-button matStepperNext (click)="emailOptionsForm.markAllAsTouched()">Next</button>
                        </div>
                    </form>
                </div>
            </mat-step>

            <mat-step completed="false">
                <div class="stepContentWrapper reviewStep">
                    <ng-template matStepLabel>Review</ng-template>
                    <h2>Review Summary</h2>
                    <section class="reviewContainer">
                        <div class="reviewHeader" fxLayout="row">
                            <h3>General Information</h3>
                            <button mat-flat-button color="primary" (click)="moveStep(0)"><mat-icon>edit</mat-icon> Edit</button>
                        </div>
                        <ul class="reviewList">
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Title</label>
                                <div class="reviewData">{{ title.value }}</div>
                            </li>
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">About</label>
                                <div class="reviewData">{{ about.value }}</div>
                            </li>
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Our Position</label>
                                <div class="reviewData">{{ ourPosition.value }}</div>
                            </li>
                        </ul>
                    </section>

                    <section class="reviewContainer">
                        <div class="reviewHeader" fxLayout="row">
                            <h3>Tracking/Resource Links</h3>
                            <button mat-flat-button color="primary" (click)="moveStep(1)"><mat-icon>edit</mat-icon> Edit</button>
                        </div>
                        <ul class="reviewList">
                            <li class="reviewItem reviewListStyles ellipsisContainer">
                                <label class="reviewLabel">Tracking Links</label>
                                <div class="reviewData">
                                    <ul class="reviewList" *ngIf="trackingLinks.value">
                                        <li class="reviewListStyles ellipsis" *ngFor="let tl of trackingLinks.controls">
                                            <span
                                                >{{ tl.get('trackingLabel').value }}:
                                                <a href="{{ tl.get('trackingLink').value }}"> {{ tl.get('trackingLink').value }} </a>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="reviewItem reviewListStyles ellipsisContainer">
                                <label class="reviewLabel">Additional Resource Links</label>
                                <div class="reviewData">
                                    <ul class="reviewList" *ngIf="resourceLinks.value">
                                        <li class="reviewListStyles ellipsis" *ngFor="let rl of resourceLinks.controls">
                                            <span
                                                >{{ rl.get('resourceLabel').value }}:
                                                <a href="{{ rl.get('resourceLink').value }}"> {{ rl.get('resourceLink').value }} </a>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </section>

                    <section class="reviewContainer">
                        <div class="reviewHeader" fxLayout="row">
                            <h3>Email Options</h3>
                            <button mat-flat-button color="primary" (click)="moveStep(2)"><mat-icon>edit</mat-icon> Edit</button>
                        </div>
                        <ul class="reviewList">
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Email Subject</label>
                                <div class="reviewData">{{ subjectOptions.value === '1' ? title.value : emailSubject.value }}</div>
                            </li>
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Email Recipients</label>
                                <div class="reviewData">
                                    <h4>Legislative Groups</h4>
                                    <ul style="margin-bottom: 12px">
                                        <li *ngFor="let group of groupsListForm.value">{{ group.groupName }}</li>
                                    </ul>
                                    <h4>Individual Members</h4>
                                    <ul style="margin-bottom: 12px">
                                        <li *ngFor="let recipient of recipient.value">{{ recipient.name }} ({{recipient.email}})</li>
                                    </ul>
                                </div>
                            </li>
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Talking Points</label>
                                <div class="reviewData">
                                    <ul>
                                        <li *ngFor="let tp of talkingPoints.controls">{{ tp.get('talkingPoint').value }}</li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </section>

                    <section class="reviewContainer">
                        <div class="reviewHeader" fxLayout="row">
                            <h3>Publishing Options</h3>
                        </div>
                        <ul class="reviewList">
                            <li class="reviewItem reviewListStyles">
                                <label class="reviewLabel">Status</label>
                                <div class="reviewData">
                                    <mat-slide-toggle [(ngModel)]="statusIsChecked"
                                        >Status: {{ statusIsChecked ? 'Active' : 'Hidden' }}</mat-slide-toggle
                                    >
                                </div>
                            </li>
                        </ul>
                    </section>

                    <div class="stepperButtons">
                        <button mat-stroked-button matStepperPrevious>Back</button>
                        <button mat-flat-button color="warn" (click)="confirmReset()">Reset</button>
                        <button mat-flat-button *ngIf="creatingNew" (click)="addItem()" color="primary">Submit</button>
                        <button mat-flat-button *ngIf="!creatingNew" (click)="editItem()" color="primary">Save</button>
                    </div>
                </div>
            </mat-step>

            <mat-step>
                <div class="stepContentWrapper">
                    <ng-template matStepLabel>Done</ng-template>
                    <p>All done.</p>
                    <p>Your {{ creatingNew ? 'form' : 'changes' }} has been {{ creatingNew ? 'submitted' : 'saved' }}.</p>
                    <div class="stepperButtons">
                        <button mat-stroked-button (click)="backToListOfLegislationItems()">Exit</button>
                        <button mat-flat-button color="primary" *ngIf="creatingNew" (click)="resetForms()">Add another</button>
                    </div>
                </div>
            </mat-step>
        </mat-stepper>
    </mat-card-content>
</mat-card>
